import { Box, styled } from "@mui/material";

export const OverviewTableHeader = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: 16,
});
